import { ISaveTreinamentoFuncionarioUseCase } from "../../../presentation/useCases/create/save_treinamento_funcionario_use_case";
import { ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";

/**
 * SaveTreinamentoFuncionarioUseCase
 */

export class SaveTreinamentoFuncionarioUseCase implements ISaveTreinamentoFuncionarioUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) { }

  async saveTreinamentoFuncionario(
    treinamentoIds: number[],
    funcionarioIds: number[],
    dataRealizacao: Date,
    local: string,
    instrutor: string,
    prazoAvaliacao: number,
  ): Promise<void> {
    await this.repository.saveTreinamentoFuncionario(
      treinamentoIds,
      funcionarioIds,
      dataRealizacao,
      local,
      instrutor,
      prazoAvaliacao,
    );
  }
}
